import React from 'react';
import { Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getDisplayValueForType } from '../../../../../../../../../../../utils/tableUtil';

const UploadDateCell = ({ attachment }) => (
  <Text
    color="greyScale.600"
    key={attachment.id}
    textAlign="left"
    whiteSpace="nowrap"
    width="160px"
  >
    {getDisplayValueForType(attachment.createdAt, 'datetime')}
  </Text>
);

UploadDateCell.propTypes = {
  attachment: PropTypes.shape({
    id: PropTypes.number,
    createdAt: PropTypes.string
  })
};

export default UploadDateCell;
